import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Item as ItemType } from '../types';
import { Item } from './Item';
import { Trash2 } from 'lucide-react';
import {
  SortableContext,
  horizontalListSortingStrategy,
} from '@dnd-kit/sortable';

interface UnassignedItemsProps {
  items: ItemType[];
  onDeleteItem: (itemId: string) => void;
}

export const UnassignedItems: React.FC<UnassignedItemsProps> = ({ items, onDeleteItem }) => {
  const { setNodeRef } = useDroppable({
    id: 'unassigned',
    data: {
      tierId: null,
    },
  });

  const { setNodeRef: setTrashRef } = useDroppable({
    id: 'trash',
    data: {
      isTrash: true,
    },
  });

  return (
    <div className="mt-8 flex gap-4">
      <div
        ref={setNodeRef}
        className="flex-1 p-6 bg-gray-200 dark:bg-gray-700/50 rounded-lg"
      >
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Unassigned Items</h2>
        <SortableContext items={items.map(item => item.id)} strategy={horizontalListSortingStrategy}>
          <div className="flex flex-wrap gap-4">
            {items.map((item) => (
              <Item key={item.id} item={item} tierId={null} />
            ))}
          </div>
        </SortableContext>
      </div>
      <div
        ref={setTrashRef}
        className="w-48 p-6 bg-red-50 dark:bg-red-900/20 rounded-lg flex flex-col items-center justify-center border-2 border-dashed border-red-200 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
      >
        <Trash2 className="w-8 h-8 text-red-500 dark:text-red-400 mb-2" />
        <span className="text-red-600 dark:text-red-400 font-medium text-center">
          Drop here to delete
        </span>
      </div>
    </div>
  );
};